import { SettingTypes } from "TypesAndInterfaces";
import React, { ReactNode } from "react";
import { useState } from "react";

export interface UpdatesValues {
  property: string;
  value: any;
  type: SettingTypes | undefined;
  channelId?: number;
  number?: boolean;
}

interface IFirstMarketplaceContext {
  newValues: UpdatesValues[];
  setNewValues: React.Dispatch<React.SetStateAction<UpdatesValues[]>>;
  shopBlacklist: number[];
  setShopBlacklist: (shopBlacklist: number[]) => void;
  invoiceBlacklist: number[];
  setInvoiceBlacklist: (invoiceBlacklist: number[]) => void;
}

export const FirstMarketplaceContext = React.createContext<IFirstMarketplaceContext>({
} as IFirstMarketplaceContext);

interface FirstMarketplaceProviderProps {
  children: ReactNode;
}

const FirstMarketplaceProvider: React.FC<FirstMarketplaceProviderProps> = ({ children }) => {
  const [newValues, setNewValues] = useState<UpdatesValues[]>([]);
  const [shopBlacklist, setShopBlacklist] = useState<number[]>([]);
  const [invoiceBlacklist, setInvoiceBlacklist] = useState<number[]>([]);

  const marketplaceContext = {
    newValues, 
    setNewValues, 
    shopBlacklist,
    setShopBlacklist,
    invoiceBlacklist,
    setInvoiceBlacklist
  }

  return (
    <FirstMarketplaceContext.Provider value={marketplaceContext}>
      {children}
    </FirstMarketplaceContext.Provider>
  );
};

export default FirstMarketplaceProvider;
